<ng-container>
    <div class="ppl-container-body">
        <div class="ppl-container-head ledger-head">
            <div class="ledger-head__titles">
                <nav class="ledger-breadcrumb" aria-label="Breadcrumb">
                    <a class="ledger-breadcrumb__link" href="javascript:void(0)">Claims &amp; Batches</a>
                    <span class="ledger-breadcrumb__sep" aria-hidden="true">›</span>
                    <span class="ledger-breadcrumb__current">{{ selectedClaimId ? 'Claim ' + selectedClaimId : 'No claim selected' }}</span>
                </nav>
                <h1 class="ledger-title">Claim Ledger</h1>
            </div>

            <div class="ledger-search">
                <label class="ledger-search__label" for="claimPplIcnSearch">PPL ICN</label>
                <input
                    id="claimPplIcnSearch"
                    nz-input
                    type="text"
                    class="ledger-search__input"
                    placeholder="Search PPL ICN"
                    [(ngModel)]="searchPplIcn"
                    (input)="searchPplIcnError = ''"
                    (keydown.enter)="onSearchByPplIcn()" />
                <button
                    type="button"
                    class="ledger-search__btn"
                    aria-label="Search by PPL ICN"
                    (click)="onSearchByPplIcn()">
                    <i class="fa fa-search" aria-hidden="true"></i>
                </button>
                @if (searchPplIcnError) {
                <span class="ledger-search__error" role="alert">{{ searchPplIcnError }}</span>
                }
            </div>
        </div>

        <div class="ppl-container">
            <div class="ppl-content-container">
                <div class="net-ledger-section">
                    <ppl-accordion [title]="'Claim'" [isOpen]="true">
                @if (claim) {
                <section class="claim-card claim-card--flat">
                    <!-- Claim identifier row -->
                    <div class="claim-card__heading">
                        <span class="claim-card__id">{{ claim.pplIcn }}</span>
                        <span class="claim-badge">{{ claim.frequencyBadge }}</span>
                    </div>
                    <div class="claim-card__icn">External ICN {{ claim.extIcn }}</div>

                    <hr class="claim-card__divider" />

                    <!-- Detail fields (matches Claim_Ledger_v1.1.html's .meta field set) -->
                    <div class="claim-fields">
                        <div class="claim-field">
                            <span class="claim-field__label">Batch Name</span>
                            <span class="claim-field__value claim-field__value--mono">{{ claim.batchName }}</span>
                        </div>
                        <div class="claim-field">
                            <span class="claim-field__label">MCO</span>
                            <span class="claim-field__value">{{ claim.mcoName }}</span>
                        </div>
                        <div class="claim-field">
                            <span class="claim-field__label">PPL ID</span>
                            <span class="claim-field__value claim-field__value--mono">{{ claim.participantPplId }}</span>
                        </div>
                        <div class="claim-field">
                            <span class="claim-field__label">Service Date</span>
                            <span class="claim-field__value">{{ claim.serviceDate }}</span>
                        </div>

                        <div class="claim-field">
                            <span class="claim-field__label">Service Code</span>
                            <span class="claim-field__value claim-field__value--mono">{{ claim.serviceCode }}</span>
                        </div>
                        <div class="claim-field">
                            <span class="claim-field__label">Authorization #</span>
                            <span class="claim-field__value claim-field__value--mono">{{ claim.authNumber }}</span>
                        </div>
                        <div class="claim-field">
                            <span class="claim-field__label">Diagnosis Code</span>
                            <span class="claim-field__value claim-field__value--mono">{{ claim.diagnosisCodes }}</span>
                        </div>
                        <div class="claim-field">
                            <span class="claim-field__label">CIN</span>
                            <span class="claim-field__value claim-field__value--mono">{{ claim.medicaidParticipantId }}</span>
                        </div>
                    </div>

                    <!-- Summary stat cards -->
                    <div class="claim-stats">
                        <div class="stat-card">
                            <span class="stat-card__label">TOTAL BILLED</span>
                            <span class="stat-card__value stat-card__value--billed">{{ claim.billedAmount }}</span>
                        </div>
                        <div class="stat-card">
                            <span class="stat-card__label">PAYMENT AMOUNT</span>
                            <span class="stat-card__value stat-card__value--charges">{{ claim.paymentAmount }}</span>
                        </div>
                        <div class="stat-card">
                            <span class="stat-card__label">OPEN AR</span>
                            <span class="stat-card__value"
                                [class.stat-card__value--ar]="!claim.openARIsZero"
                                [class.stat-card__value--ar-clear]="claim.openARIsZero">{{ claim.openAR }}</span>
                        </div>
                    </div>
                </section>
                } @else {
                <p class="ledger-empty-state">Search for a claim by PPL ICN above to view its details.</p>
                }
                    </ppl-accordion>
                </div>

                <div class="net-ledger-section">
                    <ppl-accordion [title]="'Net Ledger'" [isOpen]="true">
                        @if (!claim) {
                        <p class="ledger-empty-state">Search for a claim by PPL ICN above to view its Net Ledger.</p>
                        } @else if (netLedgerData.length === 0) {
                        <p class="ledger-empty-state">No net ledger entries found for this claim.</p>
                        } @else {
                        <ppl-list-table
                            [data]="netLedgerData"
                            [cols]="netLedgerCols"
                            [from]="'netLedger'"
                            [disableSort]="true"
                            [disableSearch]="true"
                            [showCustomSearch]="false"
                            [disableSelection]="true"
                            [gridTitle]="false"
                            [enableActions]="false"
                            [pagination]="false"
                            [loadPage]="false"
                            (rowDetailEventTs)="onNetLedgerClaimClick($event)"
                            [tableScrollable]="true"
                            [tableScrollHeight]="'420px'">
                        </ppl-list-table>

                        <div class="ledger-totals">
                            <div class="ledger-totals__item">
                                <span class="ledger-totals__label">Total Debit</span>
                                <span class="ledger-totals__value">{{ netLedgerTotals.totalDebit }}</span>
                            </div>
                            <div class="ledger-totals__item">
                                <span class="ledger-totals__label">Total Credit</span>
                                <span class="ledger-totals__value">{{ netLedgerTotals.totalCredit }}</span>
                            </div>
                            <div class="ledger-totals__item ledger-totals__item--net">
                                <span class="ledger-totals__label">Net Total</span>
                                <span class="ledger-totals__value">{{ netLedgerTotals.netTotal }}</span>
                            </div>
                        </div>
                        }
                    </ppl-accordion>
                </div>

                <div class="net-ledger-section">
                    <ppl-accordion [title]="'Source Timesheets'" [isOpen]="true">
                        @if (!claim) {
                        <p class="ledger-empty-state">Search for a claim by PPL ICN above to view its Source Timesheets.</p>
                        } @else if (sourceTimesheetData.length === 0) {
                        <p class="ledger-empty-state">No source timesheets found for this claim.</p>
                        } @else {
                        <ppl-list-table
                            [data]="sourceTimesheetData"
                            [cols]="sourceTimesheetCols"
                            [disableSort]="true"
                            [disableSearch]="true"
                            [showCustomSearch]="false"
                            [disableSelection]="true"
                            [gridTitle]="false"
                            [enableActions]="false"
                            [pagination]="true"
                            [rowsToDisplay]="10"
                            [loadPage]="true"
                            [customDataLoaded]="true"
                            [tableScrollable]="true">
                        </ppl-list-table>
                        }
                    </ppl-accordion>
                </div>

                <div class="net-ledger-section">
                    <ppl-accordion [title]="'Payments'" [isOpen]="true">
                        @if (!claim) {
                        <p class="ledger-empty-state">Search for a claim by PPL ICN above to view its Payments.</p>
                        } @else if (paymentData.length === 0) {
                        <p class="ledger-empty-state">No payments found for this claim.</p>
                        } @else {
                        <ppl-list-table
                            [data]="paymentData"
                            [cols]="paymentCols"
                            [disableSort]="true"
                            [disableSearch]="true"
                            [showCustomSearch]="false"
                            [disableSelection]="true"
                            [gridTitle]="false"
                            [enableActions]="false"
                            [pagination]="true"
                            [rowsToDisplay]="10"
                            [loadPage]="true"
                            [customDataLoaded]="true"
                            [tableScrollable]="true">
                        </ppl-list-table>
                        }
                    </ppl-accordion>
                </div>

                <div class="net-ledger-section">
                    <ppl-accordion [title]="'CDR Response'" [isOpen]="true">
                        @if (cdr) {
                        <section class="claim-card claim-card--flat">
                            <!-- CDR summary row (fields common to every event below) -->
                            <div class="cdr-summary">
                                <div class="cdr-summary__item">
                                    <span class="cdr-summary__label">CDR FILE</span>
                                    <span class="cdr-summary__value">{{ cdr.fileName }}</span>
                                </div>
                                <div class="cdr-summary__item">
                                    <span class="cdr-summary__label">FILE PROCESSED DATE</span>
                                    <span class="cdr-summary__value">{{ cdr.received }}</span>
                                </div>
                            </div>

                            <!-- Event history -->
                            <table class="cdr-table">
                                <thead>
                                    <tr>
                                        <th scope="col">EVENT CODE</th>
                                        <th scope="col">EVENT MESSAGE</th>
                                        <th scope="col">EVENT DATE</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    @for (ev of cdr.events; track ev.eventDate + ev.eventCode) {
                                    <tr>
                                        <td>
                                            <span class="cdr-badge" [class.cdr-badge--accepted]="ev.isAccepted">{{ ev.eventCodeLabel }}</span>
                                        </td>
                                        <td>{{ ev.eventMessage }}</td>
                                        <td>{{ ev.eventDate }}</td>
                                    </tr>
                                    }
                                </tbody>
                            </table>
                        </section>
                        } @else if (claim) {
                        <p class="ledger-empty-state">No CDR data found for this claim.</p>
                        } @else {
                        <p class="ledger-empty-state">Search for a claim by PPL ICN above to view its CDR Response.</p>
                        }
                    </ppl-accordion>
                </div>
            </div>
        </div>
    </div>
</ng-container>
